var paragraph_default = {
  "fontElementMap": "OQ2OF",
  "elementSpacing": "rWHrn",
  "text": "HliLS rWHrn",
  "child": "BF1L-"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
